<svc-dialog class="block w-full sm:max-w-100 sm:min-w-100" dialogStyle="empty">
	<div svc-dialog-title>
		{{ label ?? ('Lugar' | transloco) }}
	</div>

  <div
    svc-dialog-content
    class="px-5 py-5"
  >
    @if (!isLoading) {
      <form [formGroup]="form">
        <svc-select
          formControlName="departmentId"
          [label]="'Departamento' | transloco"
          [options]="departments"
          class="block mb-3"
        ></svc-select>

        <svc-select
          formControlName="areaId"
          [label]="'Área' | transloco"
          [options]="areas"
          [loading]="isAreasLoading"
          class="block mb-3"
        ></svc-select>

        @if (canSelectLocation) {
          <svc-select
            formControlName="locationId"
            [label]="'Localização' | transloco"
            [options]="locations"
            [loading]="isLocationsLoading"
            class="block mb-3"
          ></svc-select>
        }
      </form>
    } @else {
      <div class="flex justify-center py-50">
        <mat-spinner diameter="30"></mat-spinner>
      </div>
    }
  </div>

  <div
    svc-dialog-actions
    class="px-3 py-2"
  >
    <div class="flex flex-row gap-2 w-full justify-end">
      <button
        svc-outlined-btn
        id="svc-location-field-modal-select-button-cancel"
        (click)="close()"
      >
        {{ 'Cancelar' | transloco }}
      </button>

      <button
        svc-filled-btn
        id="svc-location-field-modal-select-button-save"
        (click)="save()"
        [disabled]="isLoading || (canSelectArea && !form.controls.areaId.value && !form.controls.locationId.value) || (!canSelectArea && !form.controls.locationId.value)"
      >
        {{ 'Salvar' | transloco }}
      </button>
    </div>
  </div>
</svc-dialog>
